module.exports = __webpack_public_path__ + "img/s3CardIcon5.e560e8c2.png";